import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import About from "@/pages/about/page";
import Programs from "@/pages/programs/page";
import BeautyInfo from "@/pages/beauty-info/page";
import BeautyInfoDetail from "@/pages/beauty-info/detail/page";
import Reservation from "@/pages/reservation/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/programs",
        element: <Programs />,
      },
      {
        path: "/beauty-info",
        element: <BeautyInfo />,
      },
      {
        path: "/beauty-info/:id",
        element: <BeautyInfoDetail />,
      },
      {
        path: "/reservation",
        element: <Reservation />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;